// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HiEIQ","header":"styles_header__nhUXt","body":"styles_body__8Igax","footer":"styles_footer__vuPuR"};